/**
 * Our radio form inputs return strings instead of bools
 * so we check for both values andconvert them to bools here
 * */
export const returnInputAsBoolean = (value: boolean | string | undefined) =>
  value === true || value === 'true'
